import React from 'react'
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next'
import {compose} from 'redux'
import axios from 'axios'
import Config from 'config'

import {Label} from 'semantic-ui-react'

import style from "assets/jss/material-kit-pro-react/views/contactUsStyle.js";

const styles = {
	...style,
	// full width; the iframe takes the dashboard's own height (see resize below), so the page
	// scrolls instead of a box inside it
	embed: {
		padding: '0 16px',
		'& iframe': { display: 'block', width: '100%', minHeight: 600, border: 0 },
	},
}

// @superset-ui/embedded-sdk uses syntax this webpack cannot parse, so its browser bundle is copied
// to public/ (npm run superset-sdk) and loaded as a script; it sets window.supersetEmbeddedSdk.
const loadSdk = () => window.supersetEmbeddedSdk ? Promise.resolve(window.supersetEmbeddedSdk) : new Promise((resolve, reject) => {
	const script = document.createElement('script')
	script.src = process.env.PUBLIC_URL + '/superset-embedded-sdk.js'
	script.onload = () => resolve(window.supersetEmbeddedSdk)
	script.onerror = reject
	document.body.appendChild(script)
})

// Superset dashboard, served through sunrise: /transaction/dashboard/embed picks the dashboard
// for this user's type and returns a guest token limited to the user and the users below them.
class Dashboard extends React.Component{
	constructor(props){
		super(props)
		this.state = {
			failed: false,
		}
		this.mount = React.createRef()
	}
	componentDidMount(){
		const fetchEmbed = () => axios.post(Config.ApiUrl + '/transaction/dashboard/embed').then(res => res.data)
		Promise.all([fetchEmbed(), loadSdk()])
		.then(([{id}, sdk]) => sdk.embedDashboard({
			id,
			supersetDomain: Config.ApiUrl,
			mountPoint: this.mount.current,
			fetchGuestToken: () => fetchEmbed().then(data => data.token),
			dashboardUiConfig: { hideTitle: true, filters: { expanded: true } },
		}))
		.then(embedded => {
			this.embedded = embedded
			// follow the dashboard's height as charts load and filters change
			this.resize = setInterval(() => embedded.getScrollSize().then(({height}) => {
				const iframe = this.mount.current && this.mount.current.querySelector('iframe')
				if (iframe && height) iframe.style.height = height + 'px'
			}), 1000)
		})
		.catch(err => {
			console.log(err);
			this.setState({failed: true})
		});
	}
	componentWillUnmount(){
		clearInterval(this.resize)
		this.embedded && this.embedded.unmount()
	}

	render(){
		const {classes, t} = this.props;
		return (
			<div className={classNames(classes.main, classes.mainRaised)}>
				<div className={classNames(classes.contactContent, classes.embed)}>
					{this.state.failed && <Label color='red'>{t('Dashboard unavailable')}</Label>}
					<div ref={this.mount} />
				</div>
			</div>
		)
	}

}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default compose(withTranslation(), withStyles(styles))(Dashboard);
